







import { Vue, Component } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  buildId = '';
  hideBuildId = false;

  created() {
    this.buildId = [process.env.VUE_APP_BUILD_BRANCH, process.env.VUE_APP_BUILD_NUMBER].join(' ');
    this.hideBuildId = /true/i.test(process.env.VUE_APP_HIDE_BUILD || '');
  }
}
